export let AnalysisState = /*#__PURE__*/function (AnalysisState) {
  AnalysisState["FirstAnalyzing"] = "first-analyzing";
  AnalysisState["Analyzing"] = "analyzing";
  AnalysisState["AnalyzeFailed"] = "analyze-failed";
  AnalysisState["AnalyzeDonePendingResults"] = "analyze-done-pending-results";
  AnalysisState["AnalyzeDoneFailedToFetchResults"] = "analyze-done-failed-to-fetch-results";
  AnalysisState["AnalyzeDoneResultsReady"] = "analyze-done-results-ready";
  return AnalysisState;
}({});
//# sourceMappingURL=use-panel-atom-state-types.js.map